import {Component} from 'react';
import '../../css/styles.css';

class NumberedListFancyCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, selected: false};
    }

    render() {
        this.class = "";
        if (this.props.text.textColor === "green"){
            this.class = "text-green ";
        }
    return <> 
           
    <li className={this.class}
        style={{listStyle: "none", display: "flex", alignItems: "flex-start"}} >
            <div style={{width: "20px", marginRight: "8px", flexShrink: 0 }} >
                {this.props.text.textColor === "green" ?
                    <img className="teeny_tiny_img"
                            src="/assets/checkMark.png"
                            alt="check"
                        />
                :
                    <img className="teeny_tiny_img"
                            src="/assets/XMark.png"
                            alt="xmark"
                        />
                }
            </div>

        <span style={{ flex: 1 }}>
            {this.props.text.textLine}
        </span>
    </li>
    </>
    }
}

export default NumberedListFancyCard;